module.exports = __webpack_public_path__ + "img/thumbnail_NileMonitor_m_normal.12bf9ce3.png";